import { appInitAgGrid } from "app/init/AppInitAgGrid";
import { appInitDecimal } from "app/init/AppInitDecimal";
import { appInitLogging } from "app/init/AppInitLogging";
import { appInitLogRocket } from "app/init/AppInitLogRocket";
import { appInitSentry } from "app/init/AppInitSentry";
import { appInitStylesheets } from "app/init/AppInitStylesheets";
import { appInitYup } from "app/init/AppInitYup";
import { appInitZod } from "app/init/AppInitZod";
import { appInitZxcvbn } from "app/init/AppInitZxcvbn";

export const appInit = () => {
  appInitStylesheets();
  appInitLogging();
  appInitDecimal();
  appInitLogRocket();
  appInitSentry();
  appInitYup();
  appInitZod();
  appInitZxcvbn();
  appInitAgGrid();
};
